import * as emailValidator from '@rategravity/core-lib/validate-email';
import React from 'react';
import Card from '../components/card';
import SessionCard from '../components/card/session-card';
import { TextField } from '../components/MaskedTextField';
import hubspot from '../modules/hubspot';
import styles from '../styles/form';
import { validateName } from './credit-authorization';

/**
 * Contains the cards asking email and PII of the borrower, with or without a coborrower.
 * Separate cards are needed because React isn't smart enough to look for changes
 * within model to trigger re-rendering of elements.
 */

const PiiEmailWithCoborrowerCard = ({ model, onChange, onSubmit, ...props }) => {
  const borrowerChange = onChange.bind(null, 'borrower');
  const coborrowerChange = onChange.bind(null, 'coborrower');
  const borrower = model.get('borrower');
  const coborrower = model.get('coborrower');

  return (
    <Card
      buttonType="complete"
      title={`You're on your way to a better mortgage experience!`}
      onSubmit={
        onSubmit &&
        (() => {
          hubspot.identifyContact(model.getIn(['borrower', 'email']));
          onSubmit();
        })
      }
      complete={!!PiiEmailWithCoborrowerCard.completed({ model })}
      {...props}
    >
      <br />
      <strong>No spam, ever.</strong> We&apos;ll never sell or share your email address. We use
      email to send important communications related to your financing request. You can opt-out of
      emails from us at any time.
      <TextField
        className="private"
        value={borrower.get('name')}
        style={styles.fullWidth}
        floatingLabelText="Full Name"
        onChange={borrowerChange.bind(null, 'name')}
        validate={(value) => {
          return !validateName(value) ? 'Please enter both first and last name' : '';
        }}
      />
      <TextField
        className="private"
        value={borrower.get('email')}
        style={styles.fullWidth}
        validate={(value) => {
          return !emailValidator.validate(value) ? 'Please enter a valid email' : '';
        }}
        floatingLabelText="Email Address"
        onChange={(v) => borrowerChange('email', v.trim())}
      />
      <TextField
        className="private"
        value={coborrower.get('name')}
        style={styles.fullWidth}
        floatingLabelText="Coborrower Full Name"
        onChange={coborrowerChange.bind(null, 'name')}
        validate={(value) => {
          return !validateName(value) ? 'Please enter both first and last name' : '';
        }}
      />
    </Card>
  );
};

PiiEmailWithCoborrowerCard.id = 'PiiEmailWithCoborrower';
PiiEmailWithCoborrowerCard.completed = ({ model }) =>
  emailValidator.validate(model.getIn(['borrower', 'email']) || '');

const PiiEmailNoCoborrowerCard = ({ model, onChange, onSubmit, ...props }) => {
  const borrowerChange = onChange.bind(null, 'borrower');
  const borrower = model.get('borrower');

  return (
    <Card
      buttonType="complete"
      title={`You're on your way to a better mortgage experience!`}
      onSubmit={
        onSubmit &&
        (() => {
          hubspot.identifyContact(model.getIn(['borrower', 'email']));
          onSubmit();
        })
      }
      complete={!!PiiEmailWithCoborrowerCard.completed({ model })}
      {...props}
    >
      <br />
      <strong>No spam, ever.</strong> We&apos;ll never sell or share your email address. We use
      email to send important communications related to your financing request. You can opt-out of
      emails from us at any time.
      <TextField
        className="private"
        value={borrower.get('name')}
        style={styles.fullWidth}
        floatingLabelText="Full Name"
        onChange={borrowerChange.bind(null, 'name')}
        validate={(value) => {
          return !validateName(value) ? 'Please enter both first and last name' : '';
        }}
      />
      <TextField
        className="private"
        value={borrower.get('email')}
        style={styles.fullWidth}
        validate={(value) => {
          return !emailValidator.validate(value) ? 'Please enter a valid email' : '';
        }}
        floatingLabelText="Email Address"
        onChange={(v) => borrowerChange('email', v.trim())}
      />
    </Card>
  );
};

PiiEmailNoCoborrowerCard.id = 'PiiEmailNoCoborrower';
PiiEmailNoCoborrowerCard.completed = ({ model }) =>
  emailValidator.validate(model.getIn(['borrower', 'email']) || '');

export const PiiEmailWithCoborrower = SessionCard(PiiEmailWithCoborrowerCard);
export const PiiEmailNoCoborrower = SessionCard(PiiEmailNoCoborrowerCard);



// WEBPACK FOOTER //
// ./src/cards/pii-email.js